import {
    CREATE_USER_FORM_MOVE_TO_CUTTING,
    FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_SUCCESS,
    FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_FAILURE,
    FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_REQUEST,
    FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_SUCCESS

} from "./moveToCutting.actionType";

export const MOVE_TO_CUTTING = 'moveToCutting';


let initialState = {
    loading: false,
    userform: {
        fldStyle: '',
        fldFKStyle: '',
        fldProgram: '',
        fldFKProgram: ''
    },
    programData: [],
    moveToCuttingGridData: [],
}

export let moveToCuttingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_MOVE_TO_CUTTING:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_SUCCESS:
            return {
                ...state,
                loading: false,
                programData: updatePayload
            }

        case FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_SUCCESS:
            return {
                ...state,
                loading: false,
                moveToCuttingGridData: updatePayload
            }

        case FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;

    }
}